import 'regenerator-runtime/runtime';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { AdressVerzeichnisResponse, Status } from '@ps20/bff-models';
import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutAction, CheckoutActions } from '../checkout.actions';
import { IAppState } from '../localStore';
import { PlzChangedActionPayload } from '../action-types/plzChangedActionPayload';

export const URL_VALIDIEREPLZ = '/privatschutz/api/adressverzeichnis';

export enum VALIDIEREPLZ_REQUEST_EVENTS {
  VALIDIEREPLZ_REQUEST_SUCCESSFUL = 'VALIDIEREPLZ_REQUEST_SUCCESSFUL',
  VALIDIEREPLZ_REQUEST_FAILED = 'VALIDIEREPLZ_REQUEST_FAILED',
}

export function* watchPLZValidierung() {
  yield takeEvery(
    CheckoutActions.VERSICHERUNGSNEHMER_PLZ_CHANGED,
    safeSaga(validierePLZSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    VALIDIEREPLZ_REQUEST_EVENTS.VALIDIEREPLZ_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    VALIDIEREPLZ_REQUEST_EVENTS.VALIDIEREPLZ_REQUEST_FAILED,
    safeSaga(errorCallback, App.SHOP_CHECKOUT),
  );
}

export function* validierePLZSaga(action: AnyAction) {
  if (action.type === CheckoutActions.VERSICHERUNGSNEHMER_PLZ_CHANGED) {
    const actionPayload: PlzChangedActionPayload = action.payload;
    const state: IAppState = yield select();
    if (!state.versicherungsnehmer.vnVorbelegt) {
      yield callBackend(actionPayload.plz);
    }
  }
}

function callBackend(plzVersicherungsnehmer: string) {
  const globalPut = GlobalPut.getInstance();
  return call(
    globalPut.put,
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      body: {
        plz: plzVersicherungsnehmer,
      },
      url: URL_VALIDIEREPLZ,
      successEvent: VALIDIEREPLZ_REQUEST_EVENTS.VALIDIEREPLZ_REQUEST_SUCCESSFUL,
      errorEvent: VALIDIEREPLZ_REQUEST_EVENTS.VALIDIEREPLZ_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: CheckoutAction<AdressVerzeichnisResponse>) {
  const resp: AdressVerzeichnisResponse = successAction.payload;
  if (resp.status && resp.status === Status.NOK && (resp.orte.length < 1 || resp.orte[0] === '')) {
    yield put({ type: CheckoutActions.VERSICHERUNGSNEHMER_PLZ_INVALID });
  } else {
    yield put({
      type: CheckoutActions.VERSICHERUNGSNEHMER_PLZ_VALID,
      payload: resp,
    });
  }
}

export function* errorCallback() {
  yield put({ type: CheckoutActions.VALIDIEREPLZ_SERVICE_DOWN });
}
